import {
  GeckoComponentModelType,
  GeckoMeasurementUnit,
  TUBESPACING_DEFAULT,
  type GeckoComponentDataFrame,
  type GeckoComponentModel,
} from 'types'

import type { CroppedValues } from './types'

function getTubeSpacing(componentModel: GeckoComponentModel) {
  switch (componentModel.type) {
    case GeckoComponentModelType.LegacyBoilerWalls:
    case GeckoComponentModelType.HoodStraight:
      return componentModel.tubeSpacing ?? TUBESPACING_DEFAULT
    default:
      return TUBESPACING_DEFAULT
  }
}

function toPhysicalBinSizeMeters(
  componentModel: GeckoComponentModel,
  size: GeckoComponentDataFrame['data']['binning']['bin_size']['width']
) {
  if (size.unit === GeckoMeasurementUnit.Tubes) {
    return size
      .convertFromTubes(getTubeSpacing(componentModel))
      .toNumber(GeckoMeasurementUnit.Meters)
  }

  return size.toNumber(GeckoMeasurementUnit.Meters)
}

export function getCartesianPhysicalAspectRatio(
  componentModel: GeckoComponentModel,
  cdf: GeckoComponentDataFrame,
  croppedValues: Pick<CroppedValues, 'xBinCount' | 'yBinCount'>
) {
  const xBinWidthMeters = toPhysicalBinSizeMeters(
    componentModel,
    cdf.data.binning.bin_size.width
  )
  const yBinHeightMeters = toPhysicalBinSizeMeters(
    componentModel,
    cdf.data.binning.bin_size.height
  )
  const plotWidthMeters = Math.max(
    croppedValues.xBinCount * xBinWidthMeters,
    Number.EPSILON
  )
  const plotHeightMeters = Math.max(
    croppedValues.yBinCount * yBinHeightMeters,
    Number.EPSILON
  )

  return plotHeightMeters / plotWidthMeters
}
